import React from "react";
import { COLORS } from '@gc-npm/utils.enums.colors';

const SeparatorLine = () => {
    return (
        <div className='SeparatorLine'>
            <div className='SeparatorLine_wrapper container'>
                <hr />
            </div>
            <style jsx>
                {`
                    .SeparatorLine {
                        hr {
                            border: 1px solid ${COLORS.grey200};
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default SeparatorLine;